<template>
    <header class="resume-header pt-4 pt-md-0">
        <div class="media flex-column flex-md-row">
            <img class="mr-3 img-fluid picture mx-auto"
                 src="./../../assets/profile.jpg"
                 :alt="author.name">
            <div class="media-body p-4 d-flex flex-column flex-md-row mx-auto mx-lg-0">
                <div class="primary-info">
                    <h1 class="name mt-0 mb-1 text-white text-uppercase text-uppercase">{{author.name}}</h1>
                    <div class="title mb-3">{{authorFunction}}</div>
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a :href="'mailto:' + author.email">
                                <i class="far fa-envelope fa-fw mr-2" data-fa-transform="grow-3"></i>
                                {{author.email}}
                            </a>
                        </li>
                        <li>
                            <a :href="'https://t.me/' + author.telegram" target="_blank">
                                <i class="fab fa-telegram-plane fa-fw mr-2" data-fa-transform="grow-6"></i>
                                @{{author.telegram}}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="secondary-info ml-md-auto mt-2" v-if="author.links.length">
                    <ul class="resume-social list-unstyled">
                        <li v-for="(link, index) in author.links" :key="index"
                            :class="{'mb-3': index !== author.links.length-1}">
                            <a :href="link.url" target="_blank">
                                    <span class="fa-container text-center mr-2">
                                        <i :class="link.icon"></i>
                                    </span>
                                <span class="d-md-none d-lg-none">{{link.text}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
    export default {
        name: "Author",
        computed: {
            author() {
                return this.$store.state.author;
            },
            authorFunction() {
                return this.author.i18n[this.$store.state.config.lang].function;
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "./../../sass/constants"
    .resume
        &-header
            background: $green
            color: $light-white
            height: $header-height
            @media (max-width: $mobile)
                height: auto

            .picture
                width: $header-height
                @media (max-width: $mobile)
                    width: 120px
                    border-radius: 4px

            .name
                font-size: 2.25rem
                letter-spacing: 0.175rem
                font-weight: $font-black

            .title
                font-size: 1.5rem

            a
                color: $transparent-white

                &:hover
                    color: $white

        &-social
            font-size: 0.875rem

            .fa-container
                font-size: 1rem
                display: inline-block
                width: 24px
                height: 24px
                border-radius: 0.125rem
                background: $white
                color: $green


</style>